// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { DocumentAssociation } from "../../types";

const documentAssociationsModule = {
  async findByUserId(userId: string): Promise<DocumentAssociation[]> {
    const result = await sql`
      SELECT * FROM document_associations
      WHERE user_id = ${userId}
      ORDER BY associated_at DESC
    `;
    return (result || []) as DocumentAssociation[];
  },

  async findByDocumentId(documentId: string, userId: string): Promise<DocumentAssociation | null> {
    const result = await sql`
      SELECT * FROM document_associations
      WHERE document_id = ${documentId} AND user_id = ${userId}
      LIMIT 1
    `;
    return result[0] as DocumentAssociation || null;
  },

  async create(data: Omit<DocumentAssociation, 'id' | 'associated_at'>): Promise<DocumentAssociation> {
    const result = await sql`
      INSERT INTO document_associations (
        document_id, user_id, matter_id, project_id, folder_id, goal_id, notes
      )
      VALUES (
        ${data.document_id}, ${data.user_id}, ${data.matter_id}, 
        ${data.project_id}, ${data.folder_id}, ${data.goal_id}, ${data.notes}
      )
      RETURNING *
    `;
    return result[0] as DocumentAssociation;
  },

  async update(documentId: string, userId: string, data: Partial<DocumentAssociation>): Promise<DocumentAssociation> {
    const result = await sql`
      UPDATE document_associations
      SET 
        matter_id = CASE WHEN ${data.matter_id === undefined} THEN matter_id ELSE ${data.matter_id} END,
        project_id = CASE WHEN ${data.project_id === undefined} THEN project_id ELSE ${data.project_id} END,
        folder_id = CASE WHEN ${data.folder_id === undefined} THEN folder_id ELSE ${data.folder_id} END,
        goal_id = CASE WHEN ${data.goal_id === undefined} THEN goal_id ELSE ${data.goal_id} END,
        notes = CASE WHEN ${data.notes === undefined} THEN notes ELSE ${data.notes} END
      WHERE document_id = ${documentId} AND user_id = ${userId}
      RETURNING *
    `;
    return result[0] as DocumentAssociation;
  },

  async delete(documentId: string, userId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM document_associations
      WHERE document_id = ${documentId} AND user_id = ${userId}
    `;
    return result.count === 1;
  }
};

export type DocumentAssociationsModule = typeof documentAssociationsModule;

export function registerDocumentAssociations(db: { documentAssociations?: DocumentAssociationsModule }) {
  db.documentAssociations = documentAssociationsModule;
}

export { documentAssociationsModule as documentAssociations };
